import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0aa4b230")

_pushScopeId("data-v-0aa4b230")
const _hoisted_1 = {
  key: 0,
  class: "send-email-form"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "tip" }, [
  /*#__PURE__*/_createTextVNode(" ご登録のメールアドレスをご入力ください。 "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" パスワード再設定用URLをメールにてご連絡します。 ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" パスワードを再発行する")
const _hoisted_4 = {
  key: 1,
  class: "send-completed-form"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "message" }, [
  /*#__PURE__*/_createTextVNode(" パスワード設定用のメールが送信されました。 "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" メールのリンク先よりパスワードを設定してください。 ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" ログイン画面へ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_logo = _resolveComponent("logo")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_wrapper = _resolveComponent("wrapper")

  return (_openBlock(), _createBlock(_component_wrapper, { class: "wrapper" }, {
    default: _withId(() => [
      (_ctx.isSending)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_logo, { class: "logo-pic" }),
            _hoisted_2,
            _createVNode(_component_el_form, {
              model: _ctx.ruleForm,
              rules: _ctx.rules,
              ref: "emailForm",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  prop: "email",
                  label: "メールアドレス"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      type: "email",
                      modelValue: _ctx.ruleForm.email,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.ruleForm.email = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  loading: _ctx.loading,
                  onClick: _ctx.handleResetPassword,
                  class: "reset-button"
                }, {
                  default: _withId(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_logo, { class: "logo-pic" }),
            _hoisted_5,
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleBack,
              class: "back-button"
            }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
    ]),
    _: 1
  }))
})